import script from "./ConsigneeContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsigneeContact.vue?vue&type=script&setup=true&lang=js"

import "./ConsigneeContact.vue?vue&type=style&index=0&id=2895d94e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2895d94e"]])

export default __exports__